<script>
import Swal from "sweetalert2";
import Layout from "../../layouts/main";
import appConfig from "@/app.config";
import BannerApi from "@/services/banner-api";
import ItemsApi from "@/services/items-api";

export default {
  page: {
    title: "Bannières",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    Layout,
  },
  data() {
    return {
      bannerList: [],
      pagemodelMain: { currentPage: 1, perPage: 15, totalRows: 0 },
      showBannerImageModal: false,
      showAllBanner:false,
      imageModalUrl: "",
      maxFileSize: null,
      selectedBanner: {
        id: null,
        name: null,
        generatedName:null,
        position:1,
        
      },

      formData: null,
      selectedImage: null,
      endOfFindBanner:false,
      isBannerTableBusy: false,
      //isTableBusy:false,
    };
  },

  mounted() {
    this.findBanner();
    this.getMaxFileSize();
  },

  methods: {

      getMaxFileSize(){
        ItemsApi.getMaxFileSize().then(
            size => {
                this.maxFileSize=size;
            })
    },

    findBanner() {
      this.isBannerTableBusy = true;
      //this.isTableBusy=true;
      BannerApi.getBanners().then((result) => {
        this.bannerList = result;
      }).finally(() => {
        this.isBannerTableBusy = false;
        //this.isTableBusy=false;
      })
    },

    uploadBanner() {
      const fd = new FormData();
      fd.append("file", this.selectedBanner, this.selectedBanner.name);
      BannerApi.uploadBanner(fd).then((res) => {
        if (res) {
          this.findBanner();
        }
      });
    },

    onBannerUpload(event) {
      this.selectedBanner = event.target.files[0];
      this.uploadBanner();
    },

     removeBanner(banner) {
        Swal.fire({
            title: "Supprimer la bannière?",
            html: banner.name,
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#34c38f",
            cancelButtonColor: "#f46a6a",
            cancelButtonText: "Annuler",
            confirmButtonText: "Oui, supprimer!"
        }).then(result => {
            if (result.value) {
                BannerApi.removeBanner(banner.id)
                .then(() =>{
                    this.findBanner()
                    }) 
            }
        }) 
    },

    savePosition(data){
      BannerApi.savePosition(data).then(
        result =>{
          if(result){
            this.findBanner()
          }
        }
      )},
  },
};
</script>

<template>
  <Layout>
      <div class="row pt-4 pb-4">
      <div class="col-sm-12 col-xs-6">
    <input
      type="file"
      @change="onBannerUpload"
      ref="imageInput"
      style="display: none"
    />

    <div class="card  " style="min-height: 100%; border:1px solid rgb(205, 211, 217);" >
      <div class="card-body">
        <div class="row pl-4 ">
          <div class="col-sm-10 text-left  ">
            <h4 class="card-title text-primary" style="font-size: 2em;">Liste des Bannières</h4>
            <p class="card-title-desc font-size-14"> La Liste des Bannières </p>
          </div>
        </div>

        <div class="row pl-4 pr-4 pb-4">
          <div class="col-sm-6 ">

            <b-button
              variant="success"
              class="btn btn-primary" 
              @click="showAllBanner = true"
              >
              <i class="fas fa-images font-size-18 font-weight-bold align-middle mr-2" ></i>
              <span class="font-weight-bold font-size-12">Aperçu des Bannières </span>          
            </b-button>

          </div>

      <div class="col-sm-6 text-right">
        <b-button
          variant="success"
          class="btn btn-primary"
          @click="$refs.imageInput.click()"
        >
          <i
            class="fas fa-plus-square font-size-18 font-weight-bold align-middle mr-2"
          ></i>
          <span class="font-weight-bold font-size-12">Ajouter</span>
        </b-button>
      </div>

    </div>

    <div class="row pl-4 pr-4">
      <div class="col-xl-12">
          

        <div class="card  border border-info bg-Default">
          
          <div class="table-responsive mb-0" style="min-height:25em">
           
            <table class="table table-centered " >
              
              <thead class="thead-light">
                <tr>
                  
                  <th class="text-left">Date d'ajout</th>
                  <th class="text-left">Image</th>
                  <th class="text-left" style="width:9.375em">Position</th>
                  <th class="text-right"></th>
                  <th class="text-center"></th>
                </tr>
              </thead>
             
              <tbody>
                
                <tr v-for="data in bannerList" :key="data.id">
                 
                  <td>
                    <span  class="font-size-14 font-weight-bold ">{{data.creationDateStr}} </span>
                  </td>
                  <td class="text-left font-weight-bold font-size-14">
                    {{ data.name }}
                  </td>
                   <td class="text-left">
                      <div class="input-group input-group-sm pull-right mb-0"  >
                        <b-form-input v-model="data.position" type="number" name="number" size="sm" class="no-shadow p-1" @keyup.native.enter="savePosition(data)"></b-form-input>
                            <div class="input-group-append"  size="sm" >
                              <b-button variant="link"  size="sm" class="input-group-text text-dark" @click="savePosition(data)" ><i  class="fas fa-save font-size-14"></i></b-button>
                            </div>
                        </div>
                  </td>

                  <td class="text-right">
                     <i @click="imageModalUrl= '/api/image/get/' + data.generatedName;showBannerImageModal = true;"  style="cursor: pointer;" class="far fa-eye text-primary" />
                  </td>

                  <td class="text-center ">
                    <a data-v-a99d208c="" title="supprimer" href="javascript:void(0);" @click="removeBanner(data)" :class="data.id ? '' : 'd-none'" class="action-icon text-danger ">
                      <i data-v-a99d208c="" class="mdi mdi-trash-can font-size-22 "></i>
                    </a>
                  </td>
                </tr>
              </tbody>
            </table>
             <div v-if="isBannerTableBusy" class="d-flex justify-content-center">
                  <div class="spinner-border text-success" role="status">
                            <span class=" sr-only">Chargement...</span>
                  </div>
              </div>
            <span v-if="!isBannerTableBusy && !bannerList.length" class="d-flex justify-content-center m-4 text-danger" >Aucune Bannière dans la liste</span>
          </div>
        </div>
        
        <div class="row p-t-2 ">
          <dir class="col-12">
            <b-alert show variant="warning" class="text-justify">
            <i class="mdi mdi-alert-outline mr-2"></i>La taille de l'image ne doit pas dépasser <span class="font-weight-bold" > {{this.maxFileSize}}</span>. 
            Les types supportés sont <span class="font-weight-bold"> PNG </span>, <span class="font-weight-bold">JPG </span>, <span class="font-weight-bold"> BMP</span>, et <span class="font-weight-bold">GIF</span>. 
        </b-alert>
          </dir>
    </div>
          
      </div>
      
    </div>
          </div>
    </div>
      </div>
      </div>
    

    <b-modal v-model="showBannerImageModal" 
        title="L'image de Bannière" 
        hide-footer 
        centered 
        title-class="text-warning"
        title-tag="h5"
        header-close-variant="danger"
        size="xl">
        <div class="row p-2 zoom-container">
            <img v-bind:src="imageModalUrl"  alt style="width: 100%; height: 100%;" />
        </div>
      </b-modal>

      <b-modal v-model="showAllBanner"
      title="Aperçu de la page d'accueil des clients"
      hide-footer
      centered
      title-class="text-warning"
      title-tag="h5"
      header-close-variant="danger"
      size="xl">

      <div class="zoom-container" style="background-color:#fff">
             <b-carousel
                style="text-shadow: 0px 0px 2px #000"
                img-width="5206"
                img-height="1256"
                :interval="4000"
                indicators
                controls
              >
                <b-carousel-slide caption="Restez à l'écoute!" img-blank img-alt="Blank Image " v-if="isBannerTableBusy || !bannerList || !bannerList.length ">
                  <p class="text-primary">
                    Les publicitées seront disponibles prochainement
                  </p>
                </b-carousel-slide> 

               <div v-if="!isBannerTableBusy" style="min-height:20em">
                 <div v-for="banner in bannerList" :key="banner.id">
                <b-carousel-slide 
                  :img-src="'/api/banner/get/' + banner.generatedName" 
                ></b-carousel-slide>
              </div>
               </div>
                
            </b-carousel>

          </div>
        
      </b-modal>

  </Layout>
</template>

